"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;
exports.debounce = async function debounce(ctx, next) {
    const { debounceContext } = ctx.request;
    if (debounceContext) {
        const runnable = await debounceContext.runnable();
        if (runnable) {
            await next();
        }
        else {
            throw Error(`Canceled in debounce middleware: DebounceContext(${debounceContext.name})`);
        }
    }
    else {
        await next();
    }
};
exports.debounce.id = 'debounce';
//# sourceMappingURL=debounce.js.map